import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { resetWpsDqcPage, resetWpsDqcState } from "../../../store";

const Confirmation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleGoBackHome = () => {
    dispatch(resetWpsDqcState());
    dispatch(resetWpsDqcPage(0));
    navigate("/dashboard");
  };


  useEffect(() => {
    window.scrollTo(0,200)
  }, [])

  let orderNumber = useSelector(state => state.wpsDqcForm.data.orderNumber)

  return (
    <div className="px-16">
        <h1 className='text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
			FREE TRIAL: Sequence Accuracy Showdown
        </h1>
      <div className='flex flex-col justify-center items-center'>
        <IoCheckmarkCircle className='h-[124px] w-[124px] text-[#60C5C5] mt-14 mb-10' />
        <p className='text-[var(--color-primary-purple)] font-extrabold text-3xl'>Order Confirmed!</p>
        <div className='flex flex-col justify-center items-center mt-8 mb-12'>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
            Thank you for placing an order with us.
          </p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
           Your order number is <b>{orderNumber}</b>.
          </p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
            You can track the status of your order at any time by logging into{" "}
            <Link>you account</Link>.
          </p>
          {/* <p>LInk to shipping instructions</p> */}
          <p className='mt-10 text-red-500 font-black text-2xl'>Send Us Your Sample (and primers)!</p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg text-center'>
          Ship your sample via an ACGT dropbox. A list of all nationwide dropboxes can found <a className="text-blue-600 underline" href="https://acgtinc.com/resources/dropbox-information/">here</a>.<br/> If your campus does not have an ACGT dropbox please send to: 
          </p>
			<p className='text-[var(--color-primary-purple)] font-semibold text-lg text-center w-[60%]'>ACGT<br/>35 Waltz Drive<br/>Wheeling, IL 60090<br/>Attn: Sequence Accuracy Showdown </p>
        </div>

        <button
          className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
          onClick={() => handleGoBackHome()}
        >
          go back to account home
        </button>

      </div>
    </div>
  );
};

export default Confirmation;
